<div id="providerSearchForm" class="ppl-mt20">
  <form nz-form [formGroup]="searchQueryFormGroup">
    <div nz-row nzGutter="48">
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="pplId" [nzXs]="24" [nzSm]="6" class="ppl-form-label">PPL ID</nz-form-label>
          <nz-form-control [nzXs]="24" [nzSm]="18" class="ppl-form-control">
            <input nz-input formControlName="pplId" id="pplId" placeholder="Enter PPL ID" />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="ssn" [nzXs]="24" [nzSm]="6" class="ppl-form-label">SSN</nz-form-label>
          <nz-form-control [nzXs]="24" [nzSm]="18" class="ppl-form-control">
            <input nz-input formControlName="ssn" id="ssn" placeholder="Enter SSN" (input)="limitDigits($event)" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="dob" [nzXs]="24" [nzSm]="6" class="ppl-form-label">Date of
            Birth</nz-form-label>
          <nz-form-control [nzXs]="24" [nzSm]="18" class="ppl-form-control">
            <!-- <nz-date-picker class="ppl-date-picker" [nzDropdownClassName]="'ppl-date-picker-dropdown'"
              [nzFormat]="'MM/dd/yyyy'" formControlName="dob" id="dob" type="date"></nz-date-picker> -->
            <ppl-date-picker formControlName="dob" id="dob" [showIcon]="true"
            [placeholder]="'Select Date of Birth'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'">
          </ppl-date-picker>
            <!-- <input nz-input formControlName="dob" id="dob" type="date" /> -->
          </nz-form-control>
        </nz-form-item>
      </div>

    </div>
    <div nz-row nzGutter="48">
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="firstName" [nzXs]="24" [nzSm]="6" class="ppl-form-label">First
            Name</nz-form-label>
          <nz-form-control [nzXs]="24" [nzSm]="18" class="ppl-form-control">
            <input nz-input formControlName="fname" id="firstName" placeholder="Enter First Name" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="lastName" [nzXs]="24" [nzSm]="6" class="ppl-form-label">Last
            Name</nz-form-label>
          <nz-form-control [nzXs]="24" [nzSm]="18" class="ppl-form-control">
            <input nz-input formControlName="lname" id="lastName" placeholder="Enter Last Name" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzGutter="48">
      <!-- <div class="col-12 pl-6">
        Either PPL ID or SSN is required to perform the search.
      </div> -->
    </div>
    <div class="d-flex gap-8 justify-content-end">
      <ppl-button label="Cancel" type="button" [customClass]="'ghost-button'"
        (handleClick)="cancel.emit()"></ppl-button>
      <div nz-tooltip [nzTooltipTitle]="'Please provide either PPL ID or SSN to search'" nzTooltipPlacement="topRight">
        <ppl-button label="Search" type="submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
          [iconPosition]="'right'" (handleClick)="search()" [disabled]="searchQueryFormGroup.invalid"></ppl-button>
      </div>

    </div>

  </form>

  <div class="d-flex align-item-center justify-content-center pt-3">

    @if (providers() && providers()?.length === 0) {
    <h6>No results found with the provided search criteria</h6>
    <!-- <ppl-button
        label="Add New Provider"
        type="submit"
        icon="fa fa-plus"
        [customClass]="'primary-button'"
        [iconPosition]="'right'"
        (handleClick)="addingNewProvider.emit()"
      ></ppl-button> -->
    }
  </div>
</div>

@if (showResultsList()) {
<section id="providerSearchResults">
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="providers() ?? []"
    [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true" [rowsToDisplay]="10"
    [loadPage]="false" (gridAction)="action($event)" [actionButtons]="actionButtons">
  </ppl-list-table>

  @if (selectedProviderForRelation) {
  <div class="add-relation-panel d-flex align-item-center gap-8" style="align-items:flex-start; padding:12px 4px;">
    <label [attr.for]="'relationToConsumer'" class="ppl-form-label" style="align-self:center; font-weight:600;">
      Relationship to Consumer <span aria-label="Required">*</span>
    </label>
    <div style="min-width:220px;">
      <ppl-dropdown-select id="relationToConsumer" [(ngModel)]="selectedRelation" [options]="relationshipOptions"
        [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" [ngClass]="{'error': relationError}"
        placeholder="Select relation to consumer" aria-required="true">
      </ppl-dropdown-select>
      @if (relationError) {
      <span class="pl-1 error-message" role="alert">{{relationError}}</span>
      }
    </div>
    <ppl-button ariaLabel="Save relationship to consumer" label="Save" icon="fa fa-floppy-o"
      [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="saveRelation()"></ppl-button>
  </div>
  }
</section>
}